module.exports = __webpack_public_path__ + "components/flag/static/square/mv-301b4f1327f9a897547aea9bb0b9dad1.svg";